<template>
  <div class="text-widget grid">
    <div
      class="t-text wysiwyg"
      :class="`t-text--align-${alignment}`"
      v-html="nbsp(widget.text)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PublicTextWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicTextWidget>>()
const alignment = computed(() => props.widget?.horizontal_alignment || 'left')
</script>

<style lang="scss" scoped>
.t-text {
  @include media-column(
    (
      xs: 12
    )
  );
  width: 100%;
  max-width: rem(740px);

  color: $layout-text-02;

  &--align-left {
    margin-right: auto;
  }

  &--align-center {
    margin-inline: auto;
  }

  &--align-right {
    margin-left: auto;
  }
}
</style>
